import React from 'react';

import {
  BarChartOutlined,
  ClockCircleOutlined,
  FilterOutlined,
  SwapOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import { ValidationRuleCategories } from '@recurrency/core-api-schema/dist/validationRules/common';
import { theme } from 'theme';

export const TemplateIcon = ({ icon }: { icon: ValidationRuleCategories }) => {
  switch (icon) {
    case ValidationRuleCategories.Overrides:
      return <SwapOutlined style={{ color: theme.colors.primary[500] }} />;
    case ValidationRuleCategories.Reports:
      return <BarChartOutlined style={{ color: theme.colors.primary[500] }} />;
    case ValidationRuleCategories.DailyWorkflow:
      return <ClockCircleOutlined style={{ color: theme.colors.primary[500] }} />;
    case ValidationRuleCategories.PlanningFilters:
      return <FilterOutlined style={{ color: theme.colors.primary[500] }} />;
    case ValidationRuleCategories.MinMaxAutomation:
      return <ThunderboltOutlined style={{ color: theme.colors.primary[500] }} />;
    default:
      return <></>;
  }
};
